import { KmsTypeComponent } from "@kaltura/mediaspace-shared-types";
import { ErrorBoundary } from "@kaltura/mediaspace-shared-ui";
import { getComponentFromPath } from "@kaltura/mediaspace-shared-utils";

interface PostSaveComponentProps {
    kmsComponent: KmsTypeComponent;
    display: boolean;
    formData: { entryIds: string[]; data: any };
    onClose: () => void;
}

/**
 * Post-save component that displays a component after the file upload metadata is saved successfully.
 */
export const PostSaveComponent = ({ kmsComponent, display, formData, onClose }: PostSaveComponentProps) => {
    const Component = getComponentFromPath(kmsComponent.component);

    return (
        <ErrorBoundary key={kmsComponent.name} fallback={<></>}>
            <Component
                {...{
                    ...kmsComponent.props,
                    display: display,
                    formData: formData,
                    onClose: onClose,
                }}
            />
        </ErrorBoundary>
    );
};
